import React from "react";
import { useTranslation } from "react-i18next";
import { ActivationStep } from "../../features/admin/models/AdminUserActivity";
import { formatAdminTimestamp } from "../../features/admin/utils/formatAdminTimestamp";

interface AdminActivationFunnelProps {
  steps: ActivationStep[];
}

/** The five activation steps in funnel order, each with its first timestamp or an empty mark. */
const AdminActivationFunnel: React.FC<AdminActivationFunnelProps> = ({ steps }) => {
  const { t } = useTranslation();

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6">
      <h2 className="text-lg font-semibold text-grey-10 dark:text-white">
        {t("admin.activity.title")}
      </h2>
      <ol className="mt-2 divide-y divide-grey-90 dark:divide-primary-20">
        {steps.map((step) => (
          <li
            key={step.kind}
            data-testid={`funnel-step-${step.kind}`}
            className="flex flex-wrap items-center justify-between gap-2 py-3"
          >
            <span className="font-medium text-grey-10 dark:text-white">
              {t(`admin.activity.funnel.${step.kind}`)}
              <span className="ml-2 text-sm font-normal text-grey-50 dark:text-grey-60">
                {step.count}
              </span>
            </span>
            {step.firstAt ? (
              <span className="text-sm text-grey-30 dark:text-grey-70">
                {formatAdminTimestamp(step.firstAt)}
              </span>
            ) : (
              <span className="text-sm text-grey-50 dark:text-grey-60">—</span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default AdminActivationFunnel;
